import APIServicesRegistry from "./api-services/APIServicesRegistry";
import TranslationApiService from "./api-services/TranslationApiService";

export default class Translator {


    static _translations;
    static _missing = []

    static translate(key) {
        const value = Translator._translations[key];
        if (value === undefined) {
            if (!Translator._missing.includes(key)) {
                Translator._missing.push(key);
                scheduleAtDocumentReady(() => {
                    const api = APIServicesRegistry.getService(TranslationApiService);
                    if(api)
                        api.addMissingTranslationKey({text: key});
                })
            }
            return key
        }

        return value;
    }

    static init(translations) {
        Translator._translations = translations;
    }
}

window.Translator = Translator
window.__ = Translator.translate
